<script setup lang="ts">
const { t } = useI18n()

const title = t('termsAndConditions.seo.title')
const description = t('termsAndConditions.seo.description')

useSeoMeta({
    title,
    description,
    robots: 'noindex,nofollow',
})
</script>

<template>
    <section>
        <div class="pt-[60px] pb-[40px] sm:pt-24 sm:pb-12">
            <UContainer>
                <div class="flex flex-col gap-4.5 items-center lg:max-w-[800px] mx-auto">
                    <h1 class="uppercase text-[#0A5A75] text-[30px] leading-[38px] sm:text-[46px] sm:leading-[48px] text-center">{{ t('termsAndConditions.title') }}</h1>
                </div>
            </UContainer>
        </div>
        <div class="sm:pt-24 pb-60 sm:pb-70 relative overflow-x-clip">
            <UContainer>
                <div class="flex flex-col gap-20 lg:max-w-[800px] mx-auto">
                    <div class="text-[#012C3B]">
                        <p class="font-extrabold text-[22px] leading-[36px]" v-html="t('termsAndConditions.name')"></p>
                        <p>{{ t('termsAndConditions.date') }}</p>
                    </div>
                    <div class="flex flex-col gap-12">
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section1.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section1.text1') }}</p>
                            <p class="mb-4" v-html="t('termsAndConditions.section1.info')"></p>
                            <p>{{ t('termsAndConditions.section1.text2') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section2.title')}}</h2>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2" v-html="t('termsAndConditions.section2.list.item1')"></li>
                                <li class="ml-6 mb-2" v-html="t('termsAndConditions.section2.list.item2')"></li>
                                <li class="ml-6 mb-4" v-html="t('termsAndConditions.section2.list.item3')"></li>
                            </ul>
                            <p>{{ t('termsAndConditions.section2.text') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section3.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section3.text1') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2" v-html="t('termsAndConditions.section3.list.item1')"></li>
                                <li class="ml-6 mb-2" v-html="t('termsAndConditions.section3.list.item2')"></li>
                                <li class="ml-6 mb-4" v-html="t('termsAndConditions.section3.list.item3')"></li>
                            </ul>
                            <p>{{ t('termsAndConditions.section3.text2') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section4.title')}}</h2>
                            <ol class="list-decimal">
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section4.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section4.list.item2') }}</li>
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section4.list.item3') }}</li>
                                <li class="ml-6">{{ t('termsAndConditions.section4.list.item4') }}</li>
                            </ol>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section5.title')}}</h2>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section5.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section5.list.item2') }}</li>
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section5.list.item3') }}</li>
                                <li class="ml-6 mb-4">{{ t('termsAndConditions.section5.list.item4') }}</li>
                            </ul>
                            <p>{{ t('termsAndConditions.section5.text') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section6.title')}}</h2>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section6.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section6.list.item2') }}</li>
                                <li class="ml-6">{{ t('termsAndConditions.section6.list.item3') }}</li>
                            </ul>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section7.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section7.text1') }}</p>
                            <p class="mb-4">{{ t('termsAndConditions.section7.text2') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2" v-html="t('termsAndConditions.section7.list.item1')"></li>
                                <li class="ml-6 mb-2" v-html="t('termsAndConditions.section7.list.item2')"></li>
                                <li class="ml-6" v-html="t('termsAndConditions.section7.list.item3')"></li>
                            </ul>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section8.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section8.text1') }}</p>
                            <p class="mb-4">{{ t('termsAndConditions.section8.text2') }}</p>
                            <p class="mb-4" v-html="t('termsAndConditions.section8.text3')"></p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section9.title')}}</h2>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section9.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section9.list.item2') }}</li>
                                <li class="ml-6">{{ t('termsAndConditions.section9.list.item3') }}</li>
                            </ul>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section10.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section10.text1') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section10.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section10.list.item2') }}</li>
                                <li class="ml-6 mb-4">{{ t('termsAndConditions.section10.list.item3') }}</li>
                            </ul>
                            <p class="mb-4" v-html="t('termsAndConditions.section10.text2')"></p>
                            <p>{{ t('termsAndConditions.section10.text3') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section11.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section11.text1') }}</p>
                            <p>{{ t('termsAndConditions.section11.text2') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section12.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section12.text1') }}</p>
                            <p class="mb-4">{{ t('termsAndConditions.section12.text2') }}</p>
                            <p>{{ t('termsAndConditions.section12.text3') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section13.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section13.text1') }}</p>
                            <p>{{ t('termsAndConditions.section13.text2') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section14.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section14.text1') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section14.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('termsAndConditions.section14.list.item2') }}</li>
                                <li class="ml-6 mb-4">{{ t('termsAndConditions.section14.list.item3') }}</li>
                            </ul>
                            <p>{{ t('termsAndConditions.section14.text2') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section15.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section15.text1') }}</p>
                            <p class="mb-4" v-html="`📧 ${t('termsAndConditions.section15.text2')}`"></p>
                            <p>{{ t('termsAndConditions.section15.text3') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section16.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section16.text1') }}</p>
                            <p class="mb-4" v-html="t('termsAndConditions.section16.text2')"></p>
                            <p>{{ t('termsAndConditions.section16.text3') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section17.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section17.text1') }}</p>
                            <p class="mb-4">{{ t('termsAndConditions.section17.text2') }}</p>
                            <p>{{ t('termsAndConditions.section17.text3') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('termsAndConditions.section18.title')}}</h2>
                            <p class="mb-4">{{ t('termsAndConditions.section18.text1') }}</p>
                            <p class="mb-4">{{ t('termsAndConditions.section18.text2') }}</p>
                            <p class="mb-4">{{ t('termsAndConditions.section18.text3') }}</p>
                        </div>
                    </div>
                </div>
            </UContainer>
        </div>
    </section>
</template>

<style scoped>

</style>
